export const pipe =
  (...fns) =>
  (x) =>
    fns.reduce((v, f) => f(v), x);
export const reverseArray = (arr) => arr.reverse();
export const mapArray = (mapper) => (arr) => arr.map(mapper);
export const sortArray = (mapper) => (arr) => arr.sort(mapper);
